

export const getFilterType = (type) => {
    if(type === "Finished Jewelry Sale"){
        return "JEWELRY_SALE";
    }else if(type === "Job Work"){
        return "JOB_WORK";
    }else  if(type === "Loose Diamond Sale"){
        return "DIAMOND_SALES";
    }else if(type === "Overall"){
        return "OVERALL";
    }

}

export const getFilterTypeValue = (type) => {
    if(type === "JEWELRY_SALE"){
        return "Finished Jewelry Sale";
    }else if(type === "JOB_WORK"){
        return "Job Work";
    }else  if(type === "DIAMOND_SALES"){
        return "Loose Diamond Sale";
    }else if(type === "OVERALL"){
        return "Overall";
    }

}


export const paymentRiskGradeData = [
    { grade: "Px8", minScore: 0, maxScore: 30, description: "Highest Payment Risk", category: "HIGH" },
    { grade: "Px7", minScore: 30, maxScore: 40, description: "Very High Payment Risk", category: "HIGH" },
    { grade: "Px6", minScore: 40, maxScore: 50, description: "High Payment Risk", category: "HIGH" },
    { grade: "Px5", minScore: 50, maxScore: 60, description: "Above Average Payment Risk", category: "MEDIUM" },
    { grade: "Px4", minScore: 60, maxScore: 70, description: "Average Payment Risk", category: "MEDIUM" },
    { grade: "Px3", minScore: 70, maxScore: 80, description: "Below Average Payment Risk", category: "LOW" },
    { grade: "Px2", minScore: 80, maxScore: 90, description: "Low Payment Risk", category: "LOW" },
    { grade: "Px1", minScore: 90, maxScore: 100, description: "Lowest Payment Risk", category: "LOW" }
]


export const getRiskObject = (paymentScore) =>{
    let riskMeterObject = paymentRiskGradeData.filter(element => paymentScore >= element.minScore && paymentScore <= element.maxScore);
    return riskMeterObject[0];
}